import { type AxiosResponse } from 'axios'

import axiosInstance from '@/axios'
import { type TConvocatoria } from '@/interfaces'

const convocatoriasRequests = {
  getUserConvocatorias: async (): Promise<AxiosResponse<TConvocatoria[]>> => {
    return await axiosInstance.get('/callForApplication/get/for/user')
  },
}

export default convocatoriasRequests
